module.exports = __webpack_public_path__ + "img/mesa_el_x.f87e1f54.png";